var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSoundMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7H4L8.71967 2.28033C9.19214 1.80786 10 2.14249 10 2.81066V17.1893C10 17.8575 9.19214 18.1921 8.71967 17.7197L4 13H2C1.44772 13 1 12.5523 1 12V8C1 7.44772 1.44772 7 2 7ZM12.7071 6.29289C12.3166 5.90237 11.6834 5.90237 11.2929 6.29289C10.9024 6.68342 10.9024 7.31658 11.2929 7.70711L13.5858 10L11.2929 12.2929C10.9024 12.6834 10.9024 13.3166 11.2929 13.7071C11.6834 14.0976 12.3166 14.0976 12.7071 13.7071L15 11.4142L17.2929 13.7071C17.6834 14.0976 18.3166 14.0976 18.7071 13.7071C19.0976 13.3166 19.0976 12.6834 18.7071 12.2929L16.4142 10L18.7071 7.70711C19.0976 7.31658 19.0976 6.68342 18.7071 6.29289C18.3166 5.90237 17.6834 5.90237 17.2929 6.29289L15 8.58579L12.7071 6.29289Z",
    fill: "#647FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundMute);
export default __webpack_public_path__ + "static/media/icon-sound-mute.666c99266c8ba7f74ff106e93c3be9a0.svg";
export { ForwardRef as ReactComponent };